/* lettra: Bubble-Konfigurator — eigenstaendig, angelehnt an
   lettra-configurator.js, aber ohne dessen Font-Messung: Bubble-Buchstaben
   sind Bilder (WebP-Renders der STLs), keine Glyphen. Daten und URLs kommen
   aus window.LETTRA_BUBBLE (snippets/bubble-assets.liquid).

   Der Schriftzug-Konfigurator wird von hier aus nicht beruehrt. */
(function () {
  'use strict';

  /* ---------- Geometrie der Tuerszene ----------
     Alle Werte in Prozent der Breite des VOLLEN Bildes (1536 x 2752),
     nachgemessen am 9. 8. Alle drei Tuerbilder teilen denselben Block
     (Abweichung < 0,2 % der Bildbreite) — deshalb EIN Satz Konstanten.

     Zwingend: Das Bild wird nur VERTIKAL beschnitten (Ausschnitt 59,6 %
     der Bildhoehe, object-position: top). Jeder horizontale Beschnitt
     verschoebe den Tuerblattanteil an der Bildbreite und machte den
     Massstab falsch. Alle Platzierungen rechnen deshalb gegen die volle
     Bildbreite bzw. -hoehe, nie gegen den sichtbaren Ausschnitt.
     Zur Einordnung: Tuerblatt links/rechts liegen bei 17,19 % / 84,77 %. */
  var TUER = {
    mitte: 0.5098,        /* Tuerblattmitte, Anteil der Bildbreite */
    cmZuBreite: 0.007509, /* 1 cm = 0,7509 % der Bildbreite */
    nameTop: 0.21,        /* Oberkante des Namens, Anteil der BildHOEHE.
                             Anfangs 0.17 — das sass zu hoch auf dem
                             Tuerblatt (Korrektur 9. 8.). */
    bildSeitenverhaeltnis: 2752 / 1536,
    ausschnitt: 0.596     /* sichtbarer Anteil der Bildhoehe (nur Doku:
                             der Wert steckt im aspect-ratio des CSS) */
  };

  /* Zwei Bezugsgroessen, das ist Absicht: Der MASSSTAB richtet sich nach
     der Szene (das Tuerblatt im Bild ist 90 cm), die PASST-Pruefung
     rechnet gegen 72 cm (80-cm-Tuerblatt, 90 % genutzt), weil
     Kinderzimmertueren meist 80er sind. Lieber einmal zu frueh
     umschalten. */
  var NUTZBARE_TUERBREITE_CM = 72;

  var HOEHEN = [
    { mm: 120, cm: 12 },
    { mm: 90, cm: 9 }
  ];
  /* Fallback, solange das Produkt nicht angelegt ist — Muster wie beim
     Schriftzug. 90 mm kostet 10,00 € (Preisentscheidung 10. 8., ersetzt
     die 12,00 € vom 9. 8.). */
  var FALLBACK_PRICES = { 120: 1400, 90: 1000 };

  /* Kundennamen der Farben. Die Bambu-Spulen heissen anders — Zuordnung
     fuer die Produktion (steht so in Klammern auf dem Produktionsschein):
       Zuckerwatte = Milchrosa · Himmelblau = Babyblau ·
       Abendsonne = Aprikose · Wolkenweiss = Reinweiss.
     Die Hex-Werte sind die der Spulen und bleiben bei Umbenennungen
     unveraendert.
     mix: true = nimmt am "Bunt gemischt"-Wuerfeln teil. Wolkenweiss
     bleibt bewusst draussen — im Mix sind nur die drei bunten. */
  var FARBEN = [
    { id: 'zuckerwatte', label: 'Zuckerwatte', hex: '#f7ced8', mix: true },
    { id: 'himmelblau', label: 'Himmelblau', hex: '#a5dae8', mix: true },
    { id: 'abendsonne', label: 'Abendsonne', hex: '#ffb672', mix: true },
    { id: 'wolkenweiss', label: 'Wolkenweiß', hex: '#ffffff' }
  ];
  var MIX_FARBEN = FARBEN.filter(function (f) { return f.mix; });

  /* Reine Darstellung: keine Property, keine Variante, geht nicht in den
     Warenkorb. Standard Weiss. */
  var TUERFARBEN = [
    { id: 'weiss', label: 'Weiß' },
    { id: 'grau', label: 'Grau' },
    { id: 'holz', label: 'Holz' }
  ];

  var MAX_ZEICHEN = 12;

  /* Schlagschatten relativ zur Buchstabenhoehe, validierte Werte —
     Richtung rechts unten, passend zum Licht in Render und Szene.
     Als CSS drop-shadow auf dem Wrapper, nie ins Canvas gezeichnet. */
  var SCHATTEN = { x: 0.045, y: 0.065, blur: 0.055, farbe: 'rgba(30,25,20,0.30)' };

  var LAUFWEITE = 1 / 12; /* der Buchstabenhoehe */

  /* Betragsformat und Preis-Zaehler liegen seit dem 10. 8. gemeinsam mit
     dem Schriftzug-Konfigurator in assets/lettra-zahlen.js. Die eigene
     euro()-Kopie ist damit entfallen. Die Datei wird per defer davor
     geladen (sections/lettra-bubble.liquid). */
  var Z = window.LettraZahlen;

  function cmText(v) {
    return v.toFixed(1).replace('.', ',');
  }

  function init(root) {
    if (root.dataset.init) return;
    root.dataset.init = 'true';

    var DATEN = window.LETTRA_BUBBLE;
    if (!DATEN) return;

    var els = {
      tuerbild: root.querySelector('[data-bub-tuerbild]'),
      name: root.querySelector('[data-bub-name]'),
      stagemeta: root.querySelector('[data-bub-stagemeta]'),
      text: root.querySelector('[data-bub-text]'),
      zeichen: root.querySelector('[data-bub-zeichen]'),
      hoehen: root.querySelector('[data-bub-hoehen]'),
      hoeheHinweis: root.querySelector('[data-bub-hoehe-hinweis]'),
      farben: root.querySelector('[data-bub-farben]'),
      tueren: root.querySelector('[data-bub-tueren]'),
      mix: root.querySelector('[data-bub-mix]'),
      mixRow: root.querySelector('[data-bub-mix-row]'),
      sMix: root.querySelector('[data-bub-s-mix]'),
      sDim: root.querySelector('[data-bub-s-dim]'),
      sChars: root.querySelector('[data-bub-s-chars]'),
      sTotal: root.querySelector('[data-bub-s-total]'),
      cta: root.querySelector('[data-bub-cta]'),
      ctaLabel: root.querySelector('[data-bub-cta-label]'),
      ctaDots: root.querySelector('.lettra-btn__dots'),
      error: root.querySelector('[data-bub-error]')
    };

    /* ---------- Varianten (id, Preis) ---------- */
    var variants = [];
    try {
      variants = JSON.parse(root.querySelector('[data-bubble-variants]').textContent) || [];
    } catch (e) {
      variants = [];
    }
    /* Die Optionswerte im Admin stehen in ZENTIMETERN ("12 cm" /
       "9 cm", seit 9. 8.). Gelesen wird die erste Zahl als cm —
       robust fuer "12", "12cm", "12 cm" und "12,0 cm" (deutsches
       Komma) — und intern auf mm umgerechnet, denn gerechnet wird
       hier durchgehend in mm. Ein Wert, der nicht auf 120 oder 90 mm
       fuehrt, wird verworfen. */
    function cmAusOption(text) {
      var m = String(text || '').match(/\d+(?:[.,]\d+)?/);
      if (!m) return null;
      return parseFloat(m[0].replace(',', '.'));
    }
    var variantMap = {};
    variants.forEach(function (v) {
      var cm = cmAusOption(v.o1);
      if (cm === null) cm = cmAusOption(v.o2);
      if (cm === null) return;
      var mm = Math.round(cm * 10);
      if (mm === 120 || mm === 90) variantMap[mm] = v;
    });
    function variantFor(mm) {
      return variantMap[mm] || null;
    }
    function unitPrice(mm) {
      var v = variantFor(mm);
      return v ? v.price : FALLBACK_PRICES[mm];
    }

    /* ---------- Sichtbarer Fallback-Zustand ----------
       Ein Fallback, der dieselben Werte liefert wie der echte Pfad,
       ist keine Absicherung, sondern eine Tarnung (9. 8., siehe
       docs/WERKZEUGFALLEN.md): Die Seite zeigte fertige Preise aus
       FALLBACK_PRICES, waehrend jede Bestellung am Kaufklick
       gescheitert waere. Deshalb: Fehlt eine der beiden Varianten,
       zeigt die Summe "Preis wird geprüft", der CTA ist sofort
       deaktiviert, und die Konsole nennt, welcher Optionstext ankam
       und was daraus gelesen wurde. Im Normalbetrieb tritt dieser
       Zustand nie ein. */
    var fallbackAktiv = false;
    if (!variantFor(120) || !variantFor(90)) {
      fallbackAktiv = true;
      console.warn(
        '[lettra-bubble] Variantenzuordnung unvollständig — Fallback-Preise aktiv, Bestellung gesperrt.',
        variants.length
          ? variants.map(function (v) {
              var cm = cmAusOption(v.o1);
              if (cm === null) cm = cmAusOption(v.o2);
              return {
                option1: v.o1,
                option2: v.o2,
                gelesen_mm: cm === null ? null : Math.round(cm * 10)
              };
            })
          : 'keine Variantendaten (Produkt fehlt oder Template ohne Produkt)'
      );
    }

    /* ---------- Zeichenpruefung ----------
       Harte Sperre: nur A–Z und 0–9, automatisch in Grossbuchstaben.
       Keine Umlaute, keine Leerzeichen, keine Sonderzeichen. ß faellt
       bewusst durch: toUpperCase() macht daraus 'SS' (zwei Zeichen) —
       nur einbuchstabige Ergebnisse in der Whitelist kommen durch.
       Zerlegt in Codepoints, nicht UTF-16-Einheiten — wie beim
       Schriftzug. Drei Durchsetzungspunkte: input-Filter, ?text=-Prefill,
       addToCart. */
    function zeichenPruefen(text) {
      var sauber = '', verworfen = [];
      Array.from(String(text)).forEach(function (ch) {
        var up = ch.toUpperCase();
        if (up.length === 1 && DATEN.zeichen[up]) {
          if (sauber.length < MAX_ZEICHEN) sauber += up;
          else verworfen.push(ch);
        } else {
          verworfen.push(ch);
        }
      });
      return { sauber: sauber, verworfen: verworfen };
    }

    /* ---------- Breite ----------
       Breite = Σ(breite_verhaeltnis × Hoehe) + Laufweite × (Anzahl − 1) */
    function breiteCm(text, hoeheCm) {
      if (!text) return 0;
      var summe = 0;
      for (var i = 0; i < text.length; i++) {
        summe += DATEN.zeichen[text[i]].v * hoeheCm;
      }
      return summe + LAUFWEITE * hoeheCm * (text.length - 1);
    }

    /* ---------- State (Prefill via ?text=) ---------- */
    var params = new URLSearchParams(window.location.search);
    var startText = zeichenPruefen(params.get('text') || '').sauber;
    var state = {
      text: startText,
      hoehe: 120,
      /* Hat der Kunde selbst eine Hoehe gewaehlt, schaltet die Automatik
         nicht mehr — manuelles Zurueckschalten auf 120 mm bleibt so
         moeglich. */
      hoeheManuell: false,
      farbe: 'zuckerwatte',
      /* null = einfarbig; sonst je Buchstabe eine Farb-id. Gewuerfelt
         wird in mixWuerfeln(), beendet durch Klick auf eine
         Einzelfarbe. */
      farbmix: null,
      tuer: 'weiss'
    };
    els.text.value = state.text;

    /* ---------- Bild-Cache ----------
       Jedes Zeichen wird genau einmal geladen und dann gehalten — ein
       Farbwechsel zeichnet nur neu, er laedt nichts nach. */
    var bilder = {};
    function ladeZeichen(ch) {
      if (bilder[ch]) return bilder[ch];
      bilder[ch] = new Promise(function (resolve, reject) {
        var img = new Image();
        img.onload = function () { resolve(img); };
        img.onerror = reject;
        img.src = DATEN.assets[ch];
      });
      return bilder[ch];
    }

    /* ---------- Einfaerbung: Canvas, nicht mask-image ----------
       mask-image mit WebP-Quelle funktioniert NICHT zuverlaessig — im
       Test blieben die Buchstaben unsichtbar, weil eine nicht ladbare
       Maske als vollstaendig transparent behandelt wird. Nicht erneut
       versuchen. Stattdessen je Buchstabe ein Canvas, drei Schritte:
       Schattierung zeichnen, multiply-Farbfuellung, Alphakante per
       destination-in zurueckholen. Wolkenweiss (#ffffff) laesst das
       Render unveraendert — multiply mit Weiss ist die Identitaet. */
    function malZeichen(canvas, img, hex) {
      var dpr = Math.min(window.devicePixelRatio || 1, 2);
      var cssW = parseFloat(canvas.style.width);
      var cssH = parseFloat(canvas.style.height);
      var w = Math.max(1, Math.round(cssW * dpr));
      var h = Math.max(1, Math.round(cssH * dpr));
      if (canvas.width !== w || canvas.height !== h) {
        canvas.width = w;
        canvas.height = h;
      }
      var ctx = canvas.getContext('2d');
      ctx.clearRect(0, 0, w, h);
      ctx.drawImage(img, 0, 0, w, h);              /* Schattierung inkl. Alpha */
      ctx.globalCompositeOperation = 'multiply';
      ctx.fillStyle = hex;
      ctx.fillRect(0, 0, w, h);
      ctx.globalCompositeOperation = 'destination-in';
      ctx.drawImage(img, 0, 0, w, h);              /* Alphakante zurueckholen */
      ctx.globalCompositeOperation = 'source-over';
    }

    function farbVonId(id) {
      for (var i = 0; i < FARBEN.length; i++) {
        if (FARBEN[i].id === id) return FARBEN[i];
      }
      return FARBEN[0];
    }
    /* Farbe fuer den Buchstaben an Position i — im Mix aus der
       gewuerfelten Zuordnung, sonst die eine gewaehlte Farbe. */
    function hexFuerIndex(i) {
      if (state.farbmix && state.farbmix[i]) return farbVonId(state.farbmix[i]).hex;
      return farbVonId(state.farbe).hex;
    }

    /* ---------- Farbmix wuerfeln ----------
       Jeder Buchstabe bekommt zufaellig eine der drei bunten Farben;
       zwei benachbarte nie dieselbe (bei 2 Zeichen also: beide
       verschieden). Der Pool schliesst schlicht die Farbe des linken
       Nachbarn aus — ids[-1] ist undefined, der erste Buchstabe
       wuerfelt daher aus allen dreien. */
    function mixWuerfeln(n) {
      var ids = [];
      for (var i = 0; i < n; i++) {
        var pool = MIX_FARBEN.filter(function (f) { return f.id !== ids[i - 1]; });
        ids.push(pool[Math.floor(Math.random() * pool.length)].id);
      }
      return ids;
    }

    /* ---------- Tuervorschau ----------
       Der Massstab haengt an der GEMESSENEN Breite des Bildcontainers:
       Egal wie gross die Tuer dargestellt wird, 1 cm bleibt 0,7509 %
       ihrer Breite. Positioniert wird die Zeile als Ganzes — Mitte auf
       der Tuerblattmitte, Oberkante bei 17 % der Bildhoehe — die
       Buchstaben stehen als flex-Kinder mit Laufweite als gap darin. */
    function paintPreview() {
      var wrap = els.name;
      var bildBreite = wrap.parentElement.clientWidth;
      if (!(bildBreite > 0)) return;

      var hoeheCm = state.hoehe === 120 ? 12 : 9;
      var hPx = bildBreite * TUER.cmZuBreite * hoeheCm;
      var topPx = TUER.nameTop * bildBreite * TUER.bildSeitenverhaeltnis;

      wrap.style.left = (TUER.mitte * 100) + '%';
      wrap.style.top = topPx + 'px';
      wrap.style.gap = (hPx * LAUFWEITE) + 'px';
      wrap.style.filter =
        'drop-shadow(' + (hPx * SCHATTEN.x).toFixed(1) + 'px ' +
        (hPx * SCHATTEN.y).toFixed(1) + 'px ' +
        (hPx * SCHATTEN.blur).toFixed(1) + 'px ' + SCHATTEN.farbe + ')';

      /* DOM nur neu bauen, wenn sich der Text geaendert hat — Farb- und
         Groessenwechsel arbeiten auf den vorhandenen Canvases. */
      if (wrap.dataset.text !== state.text) {
        wrap.dataset.text = state.text;
        wrap.innerHTML = '';
        for (var i = 0; i < state.text.length; i++) {
          var c = document.createElement('canvas');
          c.dataset.zeichen = state.text[i];
          wrap.appendChild(c);
        }
      }

      Array.prototype.slice.call(wrap.children).forEach(function (canvas, i) {
        var ch = canvas.dataset.zeichen;
        var d = DATEN.zeichen[ch];
        canvas.style.height = hPx.toFixed(2) + 'px';
        canvas.style.width = (hPx * d.b / DATEN.hoehePx).toFixed(2) + 'px';
        ladeZeichen(ch).then(function (img) {
          /* Zwischen Laden und Zeichnen kann sich der Text geaendert
             haben — nur zeichnen, wenn das Canvas noch im DOM haengt.
             Die Farbe wird erst hier abgefragt, damit ein schneller
             Farbwechsel waehrend des Ladens nicht die alte Farbe malt. */
          if (canvas.isConnected) malZeichen(canvas, img, hexFuerIndex(i));
        }, function () {});
      });
    }

    function tuerWechseln() {
      var t = DATEN.tueren[state.tuer];
      if (!t) return;
      els.tuerbild.src = t.src;
      els.tuerbild.srcset = t.srcset;
    }

    /* ---------- Optionen bauen (Muster wie beim Schriftzug) ---------- */
    function optButton(cls, html, onSelect) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = cls;
      b.setAttribute('role', 'radio');
      b.innerHTML = html;
      b.addEventListener('click', onSelect);
      return b;
    }
    function markSelected(container, index) {
      Array.prototype.slice.call(container.querySelectorAll('.lettra-opt')).forEach(function (el, i) {
        el.classList.toggle('is-selected', i === index);
        el.setAttribute('aria-checked', i === index ? 'true' : 'false');
      });
    }

    /* Einzeilig — Teil der Eine-Seite-Vorgabe vom 9. 8.
       KUNDENANSICHT DURCHGEHEND IN cm, GANZE ZAHLEN (12 cm, nicht
       120 mm und nicht 12,0 cm) — Vorgabe 9. 8. Intern rechnet alles
       weiter in mm (state.hoehe). Die Shopify-Optionswerte stehen
       ebenfalls in cm; die Zuordnung uebernimmt cmAusOption() beim
       Variantenparser oben. */
    HOEHEN.forEach(function (h) {
      els.hoehen.appendChild(
        optButton(
          'lettra-opt',
          '<strong>' + h.cm + ' cm</strong>',
          function () {
            state.hoehe = h.mm;
            state.hoeheManuell = true;
            render();
          }
        )
      );
    });

    /* Bewusst ohne Zusatzzeile: Die Farbe kostet nichts extra, und das
       viermal danebenzuschreiben waere nur Flaeche.
       Ein Klick auf eine Einzelfarbe beendet einen laufenden Farbmix. */
    FARBEN.forEach(function (f) {
      els.farben.appendChild(
        optButton(
          'lettra-opt lettra-opt--left',
          '<b><span class="swatch" style="background:' + f.hex + '"></span>' + f.label + '</b>',
          function () {
            state.farbe = f.id;
            state.farbmix = null;
            render();
          }
        )
      );
    });

    /* Jeder Klick wuerfelt neu — auch wenn der Mix schon laeuft. */
    if (els.mix) {
      els.mix.addEventListener('click', function () {
        state.farbmix = mixWuerfeln(state.text.length);
        render();
      });
    }

    function tuerchipsMarkieren() {
      Array.prototype.slice.call(els.tueren.children).forEach(function (el, i) {
        var aktiv = TUERFARBEN[i].id === state.tuer;
        el.classList.toggle('is-selected', aktiv);
        el.setAttribute('aria-checked', aktiv ? 'true' : 'false');
      });
    }
    /* Runde Swatches, jeweils ein kreisrunder Ausschnitt aus dem ECHTEN
       Tuerbild — so ist Farbe UND Maserung sichtbar (Holz!), ohne dass
       hier ein einziger Farbwert gepflegt werden muss. Der Ausschnitt
       liegt auf dem Tuerblatt unter dem Namen und ueber der Klinke:
       background-size 500 % zeigt ein Fuenftel der Bildbreite rund um
       den Fokuspunkt 51 % / 38 % (Prozent-Position richtet den p-%-Punkt
       des Bildes am p-%-Punkt des Kreises aus). Beschriftung nur fuer
       Screenreader — der Swatch selbst IST die Beschriftung. */
    TUERFARBEN.forEach(function (t) {
      var b = optButton('lettra-bubble__tuerchip', '', function () {
        state.tuer = t.id;
        tuerWechseln();
        tuerchipsMarkieren();
      });
      b.setAttribute('aria-label', 'Türfarbe ' + t.label);
      var quelle = DATEN.tueren[t.id];
      if (quelle) {
        b.style.backgroundImage = 'url("' + quelle.src + '")';
        b.style.backgroundSize = '500%';
        b.style.backgroundPosition = '51% 38%';
      }
      els.tueren.appendChild(b);
    });

    /* ---------- Preis-Zähler (300ms Ziffern-Interpolation) ----------
       Dieselbe Mechanik wie beim Schriftzug, aus assets/lettra-zahlen.js.
       Zwei Zustandsspeicher: Summe und CTA-Betrag zeigen dieselbe Zahl,
       sind aber zwei Knoten mit zwei Animationen.
       Betroffen ist auch die automatische Umschaltung 12 → 9 cm — sie
       aendert den Stueckpreis, der Sprung wird damit zum Lauf. */
    var totalAnim = Z.neuerZaehler();
    var ctaAnim = Z.neuerZaehler();
    function ctaBetrag(cents) {
      return 'In den Warenkorb · ' + Z.euro(cents);
    }

    /* ---------- Render ---------- */
    function render() {
      var n = state.text.length;

      /* Der Mix haengt an den Positionen des Texts — passt die Laenge
         nicht mehr (Textaenderung), wird neu gewuerfelt statt versetzt
         eingefaerbt. */
      if (state.farbmix && state.farbmix.length !== n) {
        state.farbmix = mixWuerfeln(n);
      }

      /* Automatische Groessenumschaltung: Bedingung ist die BERECHNETE
         BREITE bei 120 mm, nicht die Zeichenzahl — LILLI misst bei
         gleicher Anzahl nur 36 cm, WOLFGANG deutlich mehr als JONATHAN.
         Solange der Kunde nicht selbst gewaehlt hat, folgt die Hoehe der
         Pruefung in beide Richtungen. */
      var passt120 = breiteCm(state.text, 12) <= NUTZBARE_TUERBREITE_CM;
      if (!state.hoeheManuell) {
        state.hoehe = passt120 ? 120 : 90;
      }
      if (n > 0 && !passt120) {
        els.hoeheHinweis.textContent =
          'Bei ' + n + ' Zeichen empfehlen wir 9 cm — so passt der Name auf eine Standardtür.';
        els.hoeheHinweis.hidden = false;
      } else {
        els.hoeheHinweis.hidden = true;
      }

      var hoeheCm = state.hoehe === 120 ? 12 : 9;
      var pEach = unitPrice(state.hoehe);
      var total = n * pEach;
      var bCm = breiteCm(state.text, hoeheCm);

      paintPreview();

      els.stagemeta.textContent = n
        ? '≈ ' + cmText(bCm) + ' cm breit · ' + hoeheCm + ' cm hoch'
        : hoeheCm + ' cm Buchstabenhöhe';

      markSelected(els.hoehen, state.hoehe === 120 ? 0 : 1);
      /* Im Mix ist keine Einzelfarbe gewaehlt — Index -1 nimmt allen
         Karten die Markierung, der Mix-Button traegt sie stattdessen. */
      markSelected(els.farben, state.farbmix ? -1 : FARBEN.map(function (f) { return f.id; }).indexOf(state.farbe));
      if (els.mix) {
        els.mix.classList.toggle('is-selected', !!state.farbmix);
        els.mix.setAttribute('aria-pressed', state.farbmix ? 'true' : 'false');
      }

      /* Name, Farbe und Hoehe stehen nicht mehr in der Zusammenfassung —
         sie sind als aktive Auswahl direkt darueber sichtbar (Vorgabe
         9. 8., Konfigurator auf eine Seite). Nur der Farbmix bekommt
         eine Zeile: Die Zuordnung je Buchstabe steht nirgendwo sonst.
         Gleiches Format wie properties[Farbmix] in addToCart. */
      if (els.mixRow && els.sMix) {
        if (state.farbmix && n > 0) {
          var mixTeile = [];
          for (var zi = 0; zi < n; zi++) {
            mixTeile.push(state.text[zi] + ' ' + farbVonId(state.farbmix[zi]).label);
          }
          els.sMix.textContent = mixTeile.join(' · ');
          els.mixRow.hidden = false;
        } else {
          els.mixRow.hidden = true;
          els.sMix.textContent = '';
        }
      }
      /* Hoehe als ganze Zahl (12, nicht 12,0) — die Breite behaelt ihre
         Nachkommastelle, sie ist selten glatt. */
      els.sDim.textContent = n ? cmText(bCm) + ' × ' + hoeheCm + ' cm' : '–';
      /* Bleibt direkt gesetzt: Das ist keine Summe, sondern die
         Rechnung dahinter (Anzahl × Stueckpreis). */
      els.sChars.textContent = n + ' × ' + Z.euro(pEach);
      if (fallbackAktiv) {
        /* Kein Preis darf hier aufblitzen — festerText bricht eine
           laufende Animation ab, bevor es den Ersatztext setzt. Der CTA
           bleibt gesperrt. */
        Z.festerText(els.sTotal, totalAnim, 'Preis wird geprüft');
        Z.festerText(els.ctaLabel, ctaAnim, 'Gerade nicht bestellbar');
        els.cta.toggleAttribute('disabled', true);
      } else {
        Z.zaehleAuf(els.sTotal, totalAnim, total);
        els.cta.toggleAttribute('disabled', n === 0);
        if (n) {
          Z.zaehleAuf(els.ctaLabel, ctaAnim, total, ctaBetrag);
        } else {
          /* Ohne Betrag kein Zaehler — der gemerkte Wert wird trotzdem
             auf 0 nachgezogen, sonst liefe der Button beim naechsten
             Zeichen von der alten Summe los, waehrend die
             Zusammenfassung daneben bei 0 startet. */
          Z.festerText(els.ctaLabel, ctaAnim, 'In den Warenkorb', 0);
        }
      }
      hideError();
    }

    /* ---------- Fehler ---------- */
    function showError(msg) {
      els.error.textContent = msg;
      els.error.classList.add('is-visible');
    }
    function hideError() {
      els.error.classList.remove('is-visible');
    }
    function setLoading(on) {
      els.cta.classList.toggle('lettra-btn--loading', on);
      els.ctaDots.hidden = !on;
      els.cta.toggleAttribute('aria-disabled', on);
    }

    /* ---------- Warenkorb ----------
       Menge = Anzahl der Buchstaben; die Variantengewichte sind
       Durchschnittswerte je Buchstabe, Shopify multipliziert sie mit der
       Menge — das passt fuer das Versandprofil. */
    function addToCart() {
      var n = state.text.length;
      if (!n) {
        showError('Gib zuerst einen Namen ein.');
        els.text.focus();
        return;
      }
      /* Dritte Absicherung, wie beim Schriftzug: faengt manipuliertes
         DOM, Autofill und alles, was am input-Filter vorbeikommt. */
      var pruef = zeichenPruefen(state.text);
      if (pruef.verworfen.length || pruef.sauber !== state.text) {
        showError('Im Namen stehen Zeichen, die wir nicht fertigen können.');
        els.text.focus();
        return;
      }
      var variant = variantFor(state.hoehe);
      if (!variant) {
        showError('Diese Größe ist gerade nicht bestellbar. Bitte melde dich kurz bei uns.');
        return;
      }
      if (!variant.available) {
        showError('Diese Größe ist gerade nicht verfügbar.');
        return;
      }

      var hoeheCm = state.hoehe === 120 ? 12 : 9;
      var bCm = breiteCm(state.text, hoeheCm);

      setLoading(true);
      hideError();

      var formData = new FormData();
      formData.append('id', variant.id);
      formData.append('quantity', n);
      /* Reihenfolge = Anzeigereihenfolge im Warenkorb (Vorgabe 9. 8.):
         Name zuerst — er ist das, was der Kunde bestellt hat —, dann
         Hoehe, Farbe, Farbmix (nur im Mix), Masse. Die Hoehe steht
         ZUSAETZLICH in der Variante; deren Optionszeile ist im
         Warenkorb fuer dieses Produkt abgeschaltet (cart-drawer und
         main-cart-items), sonst stuende sie doppelt da. */
      formData.append('properties[Name]', state.text);
      formData.append('properties[Höhe]', hoeheCm + ' cm');
      /* Beim Mix muss die Zuordnung Buchstabe → Farbe mit in die
         Bestellung — sonst ist sie beim Neuladen verloren und die
         Produktion weiss nicht, was zu drucken ist. Bei einfarbiger
         Wahl entfaellt properties[Farbmix] ganz. */
      if (state.farbmix) {
        formData.append('properties[Farbe]', 'Bunt gemischt');
        var teile = [];
        for (var mi = 0; mi < state.text.length; mi++) {
          teile.push(state.text[mi] + ' ' + farbVonId(state.farbmix[mi]).label);
        }
        formData.append('properties[Farbmix]', teile.join(' · '));
      } else {
        formData.append('properties[Farbe]', farbVonId(state.farbe).label);
      }
      formData.append('properties[Maße ca.]', cmText(bCm) + ' × ' + hoeheCm + ' cm');

      var cart = document.querySelector('cart-drawer');
      if (cart && cart.getSectionsToRender) {
        formData.append(
          'sections',
          cart.getSectionsToRender().map(function (s) { return s.id; })
        );
        formData.append('sections_url', window.location.pathname);
        if (cart.setActiveElement) cart.setActiveElement(document.activeElement);
      }

      fetch((window.routes && window.routes.cart_add_url) || '/cart/add', {
        method: 'POST',
        headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' },
        body: formData
      })
        .then(function (res) { return res.json(); })
        .then(function (data) {
          setLoading(false);
          if (data.status) {
            showError(data.description || data.message || 'Das hat leider nicht geklappt. Versuch es bitte noch einmal.');
            return;
          }
          if (cart && cart.renderContents) {
            cart.renderContents(data);
          } else {
            window.location.href = (window.routes && window.routes.cart_url) || '/cart';
          }
        })
        .catch(function () {
          setLoading(false);
          showError('Keine Verbindung. Prüfe deine Internetverbindung und versuch es noch einmal.');
        });
    }

    /* ---------- Events ---------- */
    function zeichenHinweis(verworfen) {
      if (!els.zeichen) return;
      if (!verworfen.length) {
        els.zeichen.hidden = true;
        els.zeichen.textContent = '';
        return;
      }
      els.zeichen.textContent = 'Möglich sind Buchstaben A–Z und Zahlen — ohne Umlaute, Leerzeichen und Sonderzeichen.';
      els.zeichen.hidden = false;
    }

    /* Unerlaubte Zeichen erscheinen gar nicht erst im Feld, beim Tippen
       wie beim Einfuegen; Kleinbuchstaben werden beim Tippen zu
       Grossbuchstaben. Cursorposition aus dem gefilterten Praefix, in
       UTF-16-Einheiten — wie beim Schriftzug. */
    els.text.addEventListener('input', function (e) {
      var feld = e.target;
      var roh = feld.value;
      var pruef = zeichenPruefen(roh);
      if (pruef.sauber !== roh) {
        var pos = feld.selectionStart;
        var neuePos = zeichenPruefen(roh.slice(0, pos)).sauber.length;
        feld.value = pruef.sauber;
        try { feld.setSelectionRange(neuePos, neuePos); } catch (err) {}
      }
      zeichenHinweis(pruef.verworfen);
      /* Neuer Text hebt eine manuelle Groessenwahl auf: Die Automatik
         soll fuer den neuen Namen wieder frei entscheiden. */
      if (feld.value !== state.text) state.hoeheManuell = false;
      state.text = feld.value;
      render();
    });
    els.cta.addEventListener('click', addToCart);

    /* Die Tuer aendert ihre Breite mit dem Layout — dann muss der
       Massstab neu gerechnet werden. */
    if (window.ResizeObserver) {
      new ResizeObserver(function () { paintPreview(); }).observe(els.name.parentElement);
    } else {
      window.addEventListener('resize', paintPreview);
    }

    /* Header-Hoehe fuer die klebende Vorschau — dieselbe Messung wie im
       Schriftzug-Konfigurator, hier noetig, weil dessen Skript auf der
       Bubble-Seite nicht laeuft. Der CSS-Fallback (60px) unterschlaegt
       die Ankuendigungsleiste. */
    function setHeaderHeight() {
      var header = document.querySelector('.section-header');
      if (header) {
        document.documentElement.style.setProperty('--lettra-header-h', header.offsetHeight + 'px');
      }
    }
    setHeaderHeight();
    window.addEventListener('resize', setHeaderHeight);

    tuerWechseln();
    tuerchipsMarkieren();
    render();
  }

  function boot() {
    document.querySelectorAll('[data-lettra-bubble]').forEach(init);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();
